






































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { isMobile } from 'mobile-device-detect';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { IconProps, iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import UiButton from '@/components/ui/UiButton.vue';
import { mainSiteLink } from '@/utils/plugins/links';
import { formattingSecondsToStringTime } from '@/utils/helpers/helpFunctions';
import { storeModuleName as profileStoreModule } from '@/views/App/Profile/store';
import { storeModuleName as uiStoreModule } from '@/store/modules/ui';
import { IFlatItem, IChangeFavouriteList } from '@/views/App/Profile/store/interfaces';
import {
  BookingV1BookingCreateRequest,
  BookingV1DealCreateRequest,
  Profile,
  ProfileFavouritesActionEnum,
  AppealBookingStatusEnum,
} from '@/requests/mainApi';
import { INotification } from '@/store/modules/ui/interfaces';

interface Data {
  time: number;
  timer: any;
  bookedTime: number;
  iconsList: IconProps;
  bookingButtonPressed: boolean;
}

interface Methods {
  startCountdown: () => void;
  setBookingOnlineModalStatus: (value: boolean) => void;
  setBookingOnlineModalId: (value: string | number | null) => void;
  booking: () => void;
  formatTime: (time: number, mask: string) => string;
  switchFavouriteStatus: () => void;
  analyticsSend: (key: string) => void;
  onStartDealButtonClick: () => void;
  updateBookingFlat: (payload: BookingV1BookingCreateRequest) => Promise<boolean>;
  updateFavouriteFlats: (payload: IChangeFavouriteList) => Promise<void>;
  addNotification: (payload: INotification) => void;
  dropBookingFlat: (payload: number) => void;
  startDeal: (payload: BookingV1DealCreateRequest) => Promise<boolean>;
}

interface Computed {
  flatLink: string;
  flatPicture: string;
  bookingButtonText: string;
  bookingTimerText: string;
  profileIsCompleted: string;
  buttonDisabled: boolean;
  userData: Profile;
}

interface Props {
  flatModel: IFlatItem;
  bookingButtonText: string;
}

export default Vue.extend({
  name: 'FlatCard',
  components: {
    UiButton,
  },
  mixins: [iconsMixin],
  data() {
    return {
      time: 0,
      bookedTime: 0,
      timer: null,
      bookingButtonPressed: false,
      isMobile,
      AppealBookingStatusEnum,
    };
  },
  props: {
    flatModel: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    flatLink() {
      return this.flatModel.id ? `${mainSiteLink}apartments/${this.flatModel.id}` : `${mainSiteLink}apartments`;
    },
    flatPicture() {
      return this.flatModel.planImages ? this.flatModel.planImages[0] : '/flatCardPlug.png';
    },
    bookingButtonText() {
      if (this.time)
        return this.$t('app.profile.flatsList.cancelRequest', { time: this.formatTime(this.time, 'm:ss') });

      if (this.flatModel.estate /*&& this.flatModel.bookingStatus === AppealBookingStatusEnum.New*/) {
        return this.$t('app.profile.flatsList.bookingOnline');
      }

      if (this.flatModel.isBooked) return this.$t('app.profile.flatsList.requestSent');

      return this.$t('app.profile.flatsList.bookingFlat');
    },
    bookingTimerText() {
      if (this.flatModel.expiredAt) return this.formatTime(this.bookedTime, 'h:mm:ss');

      if (this.flatModel.bookingStatus === AppealBookingStatusEnum.Canceled) {
        return this.$t('app.profile.flatsList.bookingDenied');
      }

      if (this.flatModel.bookingStatus === AppealBookingStatusEnum.Done) {
        return this.$t('app.profile.flatsList.bookingDone');
      }

      return this.$t('app.profile.flatsList.bookingWait');
    },
    favouriteIcon() {
      return this.flatModel.isFavourite ? this.iconsList.favouriteIcon : this.iconsList.unfavouriteIcon;
    },
    profileIsCompleted() {
      return this.$store.getters.profileIsCompleted;
    },
    buttonDisabled() {
      if (this.flatModel.estate /* && this.flatModel.bookingStatus === AppealBookingStatusEnum.New*/) {
        return false;
      }

      return (
        this.flatModel.status === 'booked' ||
        this.flatModel.isBooked ||
        (!this.profileIsCompleted && this.bookingButtonPressed)
      );
    },
    cardAdditionClass() {
      return {
        'profile-flat-card_expanding':
          //     (
          //   !this.flatModel.estate ||
          //     !(this.flatModel.estate && this.flatModel.bookingStatus === AppealBookingStatusEnum.Booked)
          // ) &&
          !isMobile,
        'profile-flat-card_mobile': isMobile,
      };
    },
    ...mapGetters(['userData']),
  },
  created() {
    if (this.flatModel.expiredAt) {
      this.bookedTime = Math.round((new Date(this.flatModel.expiredAt).getTime() - new Date().getTime()) / 1000);

      const timer = setInterval(() => {
        if (this.bookedTime === 0) {
          clearTimeout(timer);
          this.dropBookingFlat(this.flatModel.estate);
        }
        this.bookedTime--;
      }, 1000);
    }
  },
  methods: {
    startCountdown() {
      this.analyticsSend('get_reservation');
      this.time = 5;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.timer);
          this.booking();
        }
      }, 1000);
      this.addNotification({
        message: this.$t('app.profile.flatsList.requestSentWithEmoji'),
        action: {
          text: this.$t('app.profile.flatsList.cancel'),
          handler: () => {
            this.analyticsSend('cancel_reservation');
            this.time = 0;
            clearTimeout(this.timer);
          },
        },
      });
    },
    async booking() {
      if (!this.flatModel.id || this.flatModel.isBooked || this.flatModel.status !== 'available') return;

      this.flatModel.isBooked = true;

      this.flatModel.isBooked = await this.updateBookingFlat({
        data: {
          estate: this.flatModel.id,
        },
      });
    },
    formatTime(time: number, mask: string) {
      return time >= 0 ? formattingSecondsToStringTime(time, mask) : '00:00';
    },
    onBookingButtonClick() {
      this.bookingButtonPressed = true;

      if (this.flatModel.estate /* && this.flatModel.bookingStatus === AppealBookingStatusEnum.New*/) {
        this.setBookingOnlineModalStatus(true);
        this.setBookingOnlineModalId(this.flatModel.estate);
        return;
      }

      // if (this.flatModel.isBooked) return

      if (this.time) {
        this.analyticsSend('cancel_reservation');
        clearTimeout(this.timer);
        this.time = 0;
        return;
      }

      if (!this.profileIsCompleted) return;

      this.startCountdown();
    },
    async switchFavouriteStatus() {
      if (!this.flatModel.id) return;

      if (this.flatModel.isFavourite === undefined || this.flatModel.isFavourite) {
        this.analyticsSend('remove_favorite');
        await this.updateFavouriteFlats({
          data: {
            favourites: [this.flatModel.estate || this.flatModel.id],
            favouritesAction: ProfileFavouritesActionEnum['Remove'],
          },
        });
        this.flatModel.isFavourite = false;
      } else {
        this.analyticsSend('add_favorite');
        await this.updateFavouriteFlats({
          data: {
            favourites: [this.flatModel.estate || this.flatModel.id],
            favouritesAction: ProfileFavouritesActionEnum['Add'],
          },
        });
        this.flatModel.isFavourite = true;
      }
    },
    analyticsSend(key: string) {
      this.$analytics.logEvent(key, {
        screen: 'main',
        label: `id: ${this.flatModel.id}; price: ${this.flatModel.price}; rooms: ${this.flatModel.roomsAmount}`,
      });
    },
    async onStartDealButtonClick() {
      if (!this.userData.docsIsUploaded) {
        this.addNotification({
          message: this.$t('app.profile.flatsList.noDealDocsNotUploaded'),
          action: {
            text: this.$t('app.profile.flatsList.send'),
            handler: () => {
              this.$router.push('/profile/documents');
            },
          },
        });
        return;
      }
      if (!this.userData.isVerified) {
        this.addNotification({
          message: this.$t('app.profile.flatsList.noDealNotVerified'),
        });
        return;
      }
      if (!this.flatModel.bookingId) return;
      const result = await this.startDeal({
        data: {
          appeal: this.flatModel.bookingId,
        },
      });
      if (!result) return;
      this.$router.push('/deal/ownership');
    },
    ...mapActions(profileStoreModule, ['updateBookingFlat', 'dropBookingFlat', 'startDeal']),
    ...mapActions(uiStoreModule, ['addNotification']),
    ...mapActions(['updateFavouriteFlats']),
    ...mapMutations(uiStoreModule, ['setBookingOnlineModalStatus', 'setBookingOnlineModalId']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
